import { render, staticRenderFns } from "./tnc.vue?vue&type=template&id=b3a5ee38&"
import script from "./tnc.vue?vue&type=script&lang=js&"
export * from "./tnc.vue?vue&type=script&lang=js&"
import style0 from "./tnc.vue?vue&type=style&index=0&id=b3a5ee38&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports